import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { apiClient } from '../../services/http.js';
import { useTheme } from '../../hooks/useTheme.jsx';

const ResetPasswordPage = () => {
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [info, setInfo] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');

    if (password !== confirmPassword) {
      setError('As senhas não coincidem.');
      return;
    }

    if (!token) {
      setError('Token de recuperação inválido ou ausente.');
      return;
    }

    try {
      const { res } = await apiClient.request('/auth/password-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });
      if (res.ok) {
        setInfo('Senha atualizada com sucesso! Redirecionando...');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        const data = await res.json().catch(() => ({}));
        setError(data.detail || 'Falha ao redefinir a senha.');
      }
    } catch {
      setError('Erro de conexão.');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden bg-background p-4">
      <div className="fixed top-[-20%] left-[-10%] w-[60vw] h-[60vw] rounded-full bg-primary-container/5 blur-[120px] pointer-events-none"></div>
      <div className="fixed bottom-[-20%] right-[-10%] w-[50vw] h-[50vw] rounded-full bg-primary-container/5 blur-[100px] pointer-events-none"></div>

      <div className="fixed top-4 left-4 right-4 flex justify-between z-20">
        <button onClick={() => navigate('/')} className="flex items-center gap-2 text-on-surface-variant hover:text-primary transition-colors text-sm">
          <span className="material-symbols-outlined text-[20px]">arrow_back</span>
          <span className="hidden sm:inline">Início</span>
        </button>
        <button onClick={toggleTheme} className="p-2 rounded-full text-on-surface-variant hover:text-primary hover:bg-primary/10 transition-all">
          <span className="material-symbols-outlined text-[20px]">{theme === 'dark' ? 'light_mode' : 'dark_mode'}</span>
        </button>
      </div>

      <main className="relative z-10 w-full max-w-md px-6 py-12 flex flex-col items-center">
        <div className="mb-8 flex flex-col items-center opacity-80">
          <img alt="CatholicGPT Logo" className="h-16 w-16 mx-auto rounded-full bg-white object-contain p-2 shadow-sm mb-4" src="/logo-192.png"/>
        </div>

        <div className="w-full glass-panel rounded-xl border border-outline-variant/20 shadow-2xl p-8">
          <h2 className="font-headline text-2xl font-bold text-on-surface mb-4 text-center">Nova Senha</h2>
          <p className="text-sm text-on-surface-variant mb-6 text-center">Insira sua nova senha abaixo.</p>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="relative">
              <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-on-surface-variant opacity-60 text-lg">lock</span>
              <input
                className="w-full bg-surface-container-lowest border-0 border-b border-outline-variant/30 pl-10 pr-4 py-3 text-on-surface outline-none focus:border-primary transition-colors"
                placeholder="Nova senha" required type="password"
                value={password} onChange={(e) => setPassword(e.target.value)}
                minLength={6}
              />
            </div>
            <div className="relative">
              <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-on-surface-variant opacity-60 text-lg">lock</span>
              <input
                className="w-full bg-surface-container-lowest border-0 border-b border-outline-variant/30 pl-10 pr-4 py-3 text-on-surface outline-none focus:border-primary transition-colors"
                placeholder="Confirmar nova senha" required type="password"
                value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                minLength={6}
              />
            </div>
            {error && <p className="text-error text-sm text-center">{error}</p>}
            {info && <p className="text-primary text-sm text-center">{info}</p>}
            <button className="w-full bg-primary-container hover:bg-primary text-on-primary font-medium py-3 rounded-full mt-2 transition-all" type="submit">
              Redefinir Senha
            </button>
          </form>
          <div className="mt-6 text-center">
            <Link className="text-sm text-primary font-medium" to="/login">Voltar para Login</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ResetPasswordPage;
